import { useMemo } from 'react';
import useSWR from 'swr';
import api from '../services/api';

const EMPTY_MEDICOS = [];

const fetcher = async () => {
  const result = await api.get('medicos');
  return result.data.medicos || EMPTY_MEDICOS;
};

const useMedicos = () => {
  const { data: medicos = EMPTY_MEDICOS, mutate } = useSWR('medicos', fetcher, {
    revalidateOnFocus: false, // não revalida dados antigos
    revalidateOnReconnect: false,
    revalidateIfStale: false,
    refreshInterval: 0, // sem refresh automático
    dedupingInterval: 60000,
  });

  const selectMedicos = useMemo(
    () => medicos.map(m => ({ value: m.CODMEDICO, label: m.NOMEMED })),
    [medicos]
  );

  return {
    medicos,
    selectMedicos,
    mutate,
  };
};

export default useMedicos;
